import { render, staticRenderFns } from "./treeDepartment.vue?vue&type=template&id=179db6cd&"
import script from "./treeDepartment.vue?vue&type=script&lang=js&"
export * from "./treeDepartment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports